import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import './OutstandingCallPage.css';

const OutstandingQuotesPage = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(6);
  const [filterText, setFilterText] = useState('');
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch data from Southeastern API
  useEffect(() => {
    const fetchSoutheasternData = async () => {
      try {
        const apiUrl = process.env.REACT_APP_API_URL;
        const baseUrl = apiUrl.endsWith('/') ? apiUrl.slice(0, -1) : apiUrl;
        
        const token = localStorage.getItem("token");
        if (!token) {
          toast.error("Please login again");
          return;
        }
        
        const config = { headers: { Authorization: `Bearer ${token}` } };
        const response = await axios.get(`${baseUrl}/api/southeastern`, config);
        
        if (response.data.success) {
          setData(response.data.data);
        } else {
          toast.error("Failed to fetch data");
        }
      } catch (error) {
        console.error("Error fetching Southeastern data:", error);
        toast.error("Failed to fetch data");
      } finally {
        setLoading(false);
      }
    };

    fetchSoutheasternData();
  }, []);

  // Filter data based on type and search text
  const filteredData = data.filter(item => {
    // First filter by type - show only "Outstanding Quotes" type (value 2)
    if (!item.type) return false;
    
    const typeValues = item.type.split(',').map(t => t.trim());
    if (!typeValues.includes('2')) return false;
    
    // Then apply search filter
    if (!filterText) return true;
    
    const searchText = filterText.toLowerCase();
    return (
      (item.quotationNo && item.quotationNo.toLowerCase().includes(searchText)) ||
      (item.value && item.value.toLowerCase().includes(searchText)) ||
      (item.jobNo && item.jobNo.toLowerCase().includes(searchText)) ||
      (item.dateReceived && item.dateReceived.toLowerCase().includes(searchText)) ||
      (item.station && item.station.toLowerCase().includes(searchText)) ||
      (item.descriptionOfWorks && item.descriptionOfWorks.toLowerCase().includes(searchText)) ||
      (item.chNotes && item.chNotes.toLowerCase().includes(searchText)) ||
      (item.simonNotes && item.simonNotes.toLowerCase().includes(searchText))
    );
  });

  // Sort filtered data by updatedAt (latest modified first), then by createdAt
  const sortedData = filteredData.sort((a, b) => {
    // First sort by updatedAt (if available)
    if (a.updatedAt && b.updatedAt) {
      const dateA = new Date(a.updatedAt);
      const dateB = new Date(b.updatedAt);
      if (dateA.getTime() !== dateB.getTime()) {
        return dateB.getTime() - dateA.getTime(); // Descending order (latest first)
      }
    }
    
    // If updatedAt is same or not available, sort by createdAt
    if (a.createdAt && b.createdAt) {
      const dateA = new Date(a.createdAt);
      const dateB = new Date(b.createdAt);
      return dateB.getTime() - dateA.getTime(); // Descending order (latest first)
    }
    
    // If no dates available, maintain original order
    return 0;
  });

  // Pagination
  const totalPages = Math.ceil(sortedData.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentData = sortedData.slice(startIndex, endIndex);

  const handleSchedule = (item) => {
    // Add schedule functionality here
  };

  return (
    <div className="outstanding-call-page no-max-height">
      <div className="table-container">
        {/* Control Bar */}
        <div className="control-bar">
          {/* <div className="control-left">
            <span>Show</span>
            <select 
              value={itemsPerPage} 
              onChange={(e) => setItemsPerPage(Number(e.target.value))}
              className="items-per-page"
            >
              <option value={4}>4</option>
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
            </select>
            <span>result per page</span>
          </div> */}
          
          <div className="control-right">
            <input
              type="text"
              placeholder="Filter in records..."
              value={filterText}
              onChange={(e) => setFilterText(e.target.value)}
              className="filter-input"
            />
            {/* <button 
              className="new-entry-btn"
              onClick={() => window.location.href = '/admin/southeastern/new-entry'}
              title="Add New Entry"
            >
              New Entry
            </button> */}
          </div>
        </div>

        {/* Data Table */}
        <div className="table-section">
          <div className="table-wrapper">
          <table className="data-table">
            <thead>
              <tr>
                <th>Quotation No</th>
                <th>Value</th>
                <th>Job No</th>
                <th>Date PO Received</th>
                <th>Client reference no</th>
                <th>Station</th>
                <th>Description of Works</th>
                <th>CH Notes</th>
                <th>Simon Notes</th>
                {/* <th>Action</th> */}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="10" style={{ textAlign: 'center', padding: '20px' }}>
                    Loading Outstanding Quotes data...
                  </td>
                </tr>
              ) : currentData.length === 0 ? (
                <tr>
                  <td colSpan="10" style={{ textAlign: 'center', padding: '20px' }}>
                    No Outstanding Quotes data found
                  </td>
                </tr>
              ) : (
                currentData.map((item) => (
                  <tr key={item._id || item.id}>
                    <td>{item.quotationNo || '-'}</td>
                    <td>{item.value || '-'}</td>
                    <td>{item.jobNo || '-'}</td>
                    <td>{item.dateReceived || '-'}</td>
                    <td>{item.clientReferenceNo || '-'}</td>
                    <td>{item.station || '-'}</td>
                    <td className="site-details-cell">{item.descriptionOfWorks || '-'}</td>
                    <td className="additional-notes-cell">{item.chNotes || '-'}</td>
                    <td className="additional-notes-cell">{item.simonNotes || '-'}</td>
                    {/* <td>
                      <button 
                        className="schedule-btn"
                        onClick={() => handleSchedule(item)}
                        title="Schedule"
                      >
                        Schedule
                      </button>
                    </td> */}
                  </tr>
                ))
              )}
            </tbody>
          </table>
          </div>

          {/* Pagination */}
          <div className="pagination">
          <button 
            onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
            disabled={currentPage === 1}
            className="pagination-btn"
          >
            Previous
          </button>
          <span className="pagination-info">
            Page {currentPage} of {totalPages}
          </span>
          <button 
            onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}
            disabled={currentPage === totalPages}
            className="pagination-btn"
          >
            Next
          </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OutstandingQuotesPage;
